import { useState } from 'react'
import Styles from './TopicAndMedia.module.scss'
import { Modal } from 'almanac-ui/Modal'
import { Heading } from 'blaze-ui/Heading/Heading'
import { TopicAndImages } from '../components/TopicAndImages'
import { MediaFileProcessingInfo } from '../components/MediaFileProcessingInfo'
import { TopicAndMediaProps } from './Types'

export const TopicAndMedia = ({ topic, setTopic, mediaFiles, setMediaFiles, onNext, onBack }: TopicAndMediaProps) => {
  const [isProcessing, setIsProcessing] = useState(false)

  return (
    <>
      <div className={Styles.header}>
        <Modal.BackButton onPress={onBack} />
        <Heading level={3}>Add Topic & Media</Heading>
      </div>
      <Modal.Content>
        <div className={Styles.contentContainer}>
          <TopicAndImages
            topic={topic}
            setTopic={setTopic}
            mediaFiles={mediaFiles}
            setMediaFiles={setMediaFiles}
            setIsProcessing={setIsProcessing}
          />
        </div>
        <MediaFileProcessingInfo />
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton variant="tertiary" size="lg" onPress={onBack}>
            Back
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <div className={Styles.rightFooterButtons}>
            <Modal.FooterButton onPress={onNext} variant="tertiary" size="lg" isDisabled={isProcessing}>
              Skip
            </Modal.FooterButton>
            <Modal.FooterButton onPress={onNext} size="lg" isDisabled={isProcessing}>
              Review Post Times
            </Modal.FooterButton>
          </div>
        </Modal.FooterContent>
      </Modal.Footer>
    </>
  )
}
